import { ONLINE_STATUS } from '../../utils/useOnlineStatus';

export const useOfflineProofQuery = () => (query: any) => {
  if (!ONLINE_STATUS.online) ONLINE_STATUS.queries.push(query);
  else if (query) query();
};
